import getApiClient from '@/plugins/api'

export default {
    updatePassword: function() {
        const self = this,
            api = getApiClient(self.$store),
            userId = self.$store.state.user.id

        self.errorResponse = null
        self.successResponse = null

        self.$store.commit('startLoading')

        if (self.password !== self.passwordConfirmation) {
            self.errorResponse = 'A senha e a confirmação precisam ser iguais'
            self.$store.commit('stopLoading')
            return
        }

        if (! self.password || ! self.passwordConfirmation) {
            self.errorResponse = 'Todos os campos são obrigatórios'
            self.$store.commit('stopLoading')
            return
        }

        api.patch(`/users/${userId}/change_password`, {
            password: self.password
        }, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.errorResponse = null
                self.successResponse = 'Senha atualizada!'
            })
            .catch(() => {
                self.successResponse = null
                self.successResponse = 'Ocorreu um erro ao atualizar a senha. Tente novamente mais tarde'
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    }
}
